import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"

import {Links} from "../styled"
import ContextSwitch from "./MenuContexts"

interface Props {
  isPanelOpen: boolean
  menuContext: string | undefined
  showAppBanner?: boolean
  togglePanel: (key?: string) => void
}

class MobileMenuOptions extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  render() {
    const {isPanelOpen, menuContext, showAppBanner, togglePanel} = this.props

    return (
      <Links showAppBanner={showAppBanner} className={isPanelOpen && "mobileLinksOpen"} onClick={() => togglePanel(menuContext)}>
        <ContextSwitch currentContext={menuContext} />
      </Links>
    )
  }
}

export default MobileMenuOptions
